export function canUserAccessFolder(folder, user) {
    if (user && (user.role === "admin" || user.role === "manager")) {
        return true;
    }

    if (!folder.groups || folder.groups.length === 0) {
        return true;
    }

    if (user?.groups) {
        return folder.groups.some((groupId) => user.groups.includes(groupId));
    }

    return false;
}
